// extracted by mini-css-extract-plugin
export default {"activityList":"activity-list_activityList__ghB2N","loadingContainer":"activity-list_loadingContainer__el+SQ"};